import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { WizardComponent as BaseWizardComponent } from "angular-archwizard";
import { Location } from "@angular/common";
import { AlertService } from "src/app/services/alert.service";
import { ActivatedRoute } from "@angular/router";
import { SharedpopupComponent } from "../../master/vehicle/sharedpopup.component";
import { MatDialogRef } from "@angular/material/dialog";
import { CashBookingService } from "src/app/services/cashbooking.service";
import { GenericValidator } from "src/app/views/layout/validators/generic-validator";
import { NavigationService } from "src/app/services/navigation.service";
import * as moment from "moment";
import { ProductService } from "src/app/services/product.service";
import { TranslateService } from "@ngx-translate/core";
import swal from "sweetalert2";
import { DriverService } from "src/app/services/driver.service";
import { MatPaginator } from "@angular/material/paginator";

import { MatSort } from "@angular/material/sort";
import * as _ from "lodash";
import { MatTableDataSource } from "@angular/material/table";
import { Lightbox } from "ngx-lightbox";
import { VehicleService } from "src/app/services/vehicle.service";

@Component({
  selector: "app-addproduct",
  templateUrl: "./addproduct.component.html",
  styleUrls: ["./addproduct.component.scss"]
})
export class AddproductComponent implements OnInit {
  form: FormGroup;
  form1: FormGroup;
  form2: FormGroup;
  attachmentData: any[] = [];
  isSubmit: boolean = false;
  categoryTypeList: any[] = [];
  categoryTypeListCopy: any[] = [];
  unitTypeList: any[] = [];
  unitTypeListCopy: any[] = [];
  monthsList: any;
  filtermonthsList: any[] = [];
  filteryearsList: any[] = [];
  yearsList: any;
  fileType: any;
  productImageFileName: any;
  productImagefiles: any;
  filesResult: any;
  leafletFileName: any;
  leafletfiles: any;
  videoFileName: any;
  videofiles: any;
  same: boolean = false;
  different: boolean = false;
  importyes: boolean = false;
  importno: boolean = true;
  id: any;
  products: any[];
  districtList: any[];
  districtListCopy: any[];
  routeParams: any;
  actionInfo: any;
  submitbtn: string;
  formEditMode: boolean;
  isReadOnly: boolean;
  isDisable: boolean;
  show: boolean = false;
  show1: boolean = false;
  gst: any;
  unitprice: any;
  event: any;
  @ViewChild("wizardForm") wizardForm: BaseWizardComponent;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("myFileInput") myFileInput;
  primemover: boolean;
  Dropyears: any[] = [];
  import_filename: any;
  import_file: any;
  import: any;
  invoice_filename: any;
  productvalid: any;
  maxim: number;
  minim: number;
  newunitPrice: any;
  financeyear: any;
  hide: boolean;
  hide1: boolean;
  capacityName: any;
  dateDisabled: boolean = true;
  stateEffectiveDate: any;

  onFileChange(event) {
    this.myFileInput.nativeElement.value = "";
  }

  impName: any[];
  state: boolean = false;
  district: boolean = false;
  testedyes: boolean = false;
  testedno: boolean = false;
  // required:boolean =false;
  step1: string;
  step2: string;
  step3: string;
  subDistrictList: any[];
  subDistrictListCopy: any;
  testFromList: any[];
  testFromListCopy: any[];
  testFileName: any;
  testfiles: any;
  datas: boolean = false;
  make: any;
  model: any;
  minDate: Date;
  today: Date;
  max: Date | any;
  categoryType: any;
  classification: any;
  product: any;
  classificationList: any[];
  classificationListCopy: any[];
  disabledField: boolean = false;
  implementList: any[] = [];
  implementListCopy: any[] = [];
  productName: any;
  schemeName: string;
  attachmentsDataSource = new MatTableDataSource([]);
  images: any[];
  selectedFileName: any;
  attachmentlen: any[] = [];
  gstList: any[] = [];
  gstListCopy: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private httpClient: HttpClient,
    private genericValidator: GenericValidator,
    route: ActivatedRoute,
    private productService: ProductService,
    private navigationService: NavigationService,
    private cashBookingService: CashBookingService,
    private driverService: DriverService,
    private translate: TranslateService,
    private alertService: AlertService,
    private _location: Location,
    private _lightbox: Lightbox,
    private vehicleService: VehicleService
  ) {
    this.districtList = [];
    this.districtListCopy = [];
    this.routeParams = route.snapshot.params;
    this.id = +this.routeParams.id;
    this.actionInfo = this.routeParams.actionInfo;
    this.product = this.routeParams.product;
    this.classification = JSON.parse(this.routeParams.classification);
    this.categoryType = JSON.parse(this.routeParams.categoryType);
    if (this.actionInfo == 1) {
      this.formEditMode = false;
    }
    if (this.classification == 1 && this.categoryType == 1) {
      this.primemover = true;
    } else {
      this.primemover = false;
    }

    this.importyes = false;
    this.importno = true;
  }

  ngOnInit(): void {
    this.initializeValidators();
    this.getProductDetail(true);
    // this.get();
    this.importyes = false;
    this.importno = true;
    // this.import = event.value;
    this.form.controls["import_file"].setValidators(null);
    this.form.controls["import_file"].updateValueAndValidity();
  }

  changeOption(event: any) {
    if (event.value == 1) {
      this.importyes = true;
      // this.importyes = event.value;
      this.importyes = true;
      this.importno = false;
      this.form.controls["import_file"].setValidators(Validators.required);
      this.form.controls["import_file"].updateValueAndValidity();
    } else {
      this.importyes = false;
      this.importno = true;
      // this.import = event.value;
      this.form.controls["import_file"].setValidators(null);
      this.form.controls["import_file"].updateValueAndValidity();
    }
  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      id: [this.id, Validators.required],
      classification: [""],
      categoryType: [""],
      make: ["", [Validators.required]],
      // implementType: ['', [Validators.required]],
      model: ["", [Validators.required]],
      capicity: [null],
      // hrs: [null, { validators: [Validators.required, Validators.min(this.minHrs), Validators.max(this.maxHrs)] }],

      unitType: [""],
      driveType: [""],
      releasedate: ["", [Validators.required]],
      // releasemonth: ['', [Validators.required]],
      warrantyYear: ["", [Validators.required]],
      warrantyMonth: ["", [Validators.required]],
      warrantyHour: [""],
      specification: ["", [Validators.required]],
      specialFeature: [""],
      import: [""],
      productImage_file: [null],
      productImage_filename: [null],
      leaflet_file: ["", Validators.required],
      leaflet_filename: ["", ""],
      import_file: [""],
      import_filename: ["", ""],
      video_file: [""],
      video_filename: ["", ""],
      website: [""]
    });
    this.form1 = this.formBuilder.group({
      financialYear: [""],
      stateEffectiveDate: ["", Validators.required],
      effectiveEndDate: ["", Validators.required],
      unitPrice: ["", Validators.required],
      price: ["", Validators.required],
      dbtgstId: ["", Validators.required],
      invoice_file: ["", Validators.required],
      invoice_filename: ["", ""],
      TelematicsCost: [0],
    });
    this.form2 = this.formBuilder.group({
      testfrom: ["", Validators.required],
      testreportno: ["", Validators.required],
      startdate: ["", Validators.required],
      enddate: ["", Validators.required],
      test_file: ["", Validators.required],
      test_filename: ["", ""]
    });
  }

  ischangeEvent() {
    var date = moment(this.form2.value.startdate).format("YYYY-MM-DD");
    this.minDate = new Date(date);
  }

  getProductDetail(refresh: any) {
    this.productService
      .getProductDetail(this.product, refresh)
      .subscribe(result => {
        if (result) {
          this.maxim = result.maximum;
          this.minim = result.minimum;
          this.capacityName = result.capacityName;
          this.initializeValidators();
          //setting the maximum and minimum values, hide and show the
          if (this.maxim == 0 && this.minim == 0) {
            this.hide = true;
          } else if (this.maxim == 0 && this.minim != 0) {
            this.hide = false;
            this.hide1 = true;
            this.form.controls["capicity"].setValidators([
              Validators.required,
              Validators.min(this.minim)
            ]);
          } else {
            this.hide = false;
            this.hide1 = false;
            this.form.controls["capicity"].setValidators([
              Validators.required,
              Validators.min(this.minim),
              Validators.max(this.maxim)
            ]);
          }
          this.form.controls["classification"].setValue(
            result.machinaryClassification
          );
          this.form.controls["categoryType"].setValue(result.machinaryCategory);
          this.form.controls["driveType"].setValue(result.driveName);
          this.form.controls["unitType"].setValue(result.unitName);
          this.productName = result.productName;
          this.schemeName = "SMAM"; // result.schemeName;

          this.getUnitType();
          this.getDistricts();
          this.getTestedFrom();
          this.getgstList(true);
          this.disabledField = true;
          this.datas = false;
          this.today = new Date();
          this.max = new Date(
            moment(new Date())
              .add(1, "days")
              .format("YYYY, MM, DD")
          );
          this.getMonthsJson();
          // this.getYearJson();
          this.financialyearListLookup()
          this.state = true;
          this.testedyes = true;
          // this.maxim = this.productvalid.maximum;
          // this.minim = this.productvalid.minimum;
          if (this.id != 0) {
          }
          if (window.screen.width < 768) {
            this.step1 = "I";
            this.step2 = "II";
            this.step3 = "III";
          } else {
            this.step1 = "Step I";
            this.step2 = "Step II";
            this.step3 = "Step III";
          }
        }
      });
  }
  getgstList(refresh: boolean) {
    this.productService.getgstList(refresh).subscribe(result => {
      if (result) {
        this.gstList = result;
        this.gstListCopy = this.gstList;
        this.gstListCopy = this.gstListCopy.slice();
        this.form1.controls["dbtgstId"].setValue(1);
      }
    });
  }

  // onChange() {
  //   this.gst = this.gstListCopy.filter(i => i.key == this.form1.value.dbtgstId);
  //   this.unitprice =
  //     this.newunitPrice * (this.gst[0].price / 100) + this.newunitPrice;
  //   this.form1.controls["price"].setValue(this.unitprice);
  // }

  getTestedFrom() {
    this.testFromList = [];
    this.testFromListCopy = [];
    this.productService.getTestedFrom(true).subscribe(result => {
      if (result) {
        this.testFromList = result;
        this.testFromListCopy = this.testFromList;
        this.testFromListCopy = this.testFromListCopy.slice();
      }
    });
  }

  ontestFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (file.type === "application/pdf") {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 5000) {
        this.testFileName = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.testfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form2.controls["test_file"].setValue(this.filesResult);
            this.form2.controls["test_filename"].setValue(file.name);
            this.attachmentData.push({
              id: this.attachmentData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 22
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than  5MB"
        );
      }
    } else {
      this.alertService.warning("Please PDF only");
    }
  }

  getUnitType() {
    this.unitTypeList = [];
    this.unitTypeListCopy = [
      {
        key: 1,
        value: "BHP"
      },
      {
        key: 2,
        value: "LTR/HR"
      },
      {
        key: 3,
        value: "HA/HR"
      },
      {
        key: 4,
        value: "KG/HR"
      },
      {
        key: 5,
        value: "UNIT"
      },
      {
        key: 6,
        value: "PTO HP"
      }
    ];
  }

  getMonthsJson() {
    this.httpClient.get("assets/monthsreport.json").subscribe(data => {
      if (data) {
        this.monthsList = [];
        this.filtermonthsList = [];
        this.monthsList = data;
        this.filtermonthsList = this.monthsList.slice();
      }
    });
  }

  financialyearListLookup() {
    this.vehicleService.vehicletargetFinancialyear(true).subscribe((result) => {
      this.yearsList = [];
      this.yearsList = result;
      this.filteryearsList = this.yearsList;
      if (this.filteryearsList.length === 1) {
        this.form.controls["releasedate"].setValue(
          this.filteryearsList[0]
        );
      }
      else {
        let currentYear = new Date().getFullYear();
        this.form.controls['releasedate'].setValue(currentYear)
      }
    });
  }


  getYearJson() {
    this.httpClient.get("assets/dbtyearreport.json").subscribe(data => {
      if (data) {
        this.yearsList = [];
        this.filteryearsList = [];
        this.yearsList = _.orderBy(data, ["value"], ["desc"]);
        this.filteryearsList = this.yearsList.slice();
      }
    });
  }

  changeOptions(event: any) {
    if (event.value == 1) {
      this.state = true;
      this.district = false;
    } else {
      this.state = false;
      this.district = true;
    }
  }

  changetest(event: any) {
    if (event.value == 1) {
      this.testedyes = true;
      this.testedno = false;
    } else {
      this.testedyes = false;
      this.testedno = true;
    }
  }

  getDistricts() {
    this.districtList = [];
    this.cashBookingService.districtBySubDivision(1, true).subscribe(result => {
      if (result) {
        this.districtList = result;
        this.districtListCopy = this.districtList;
        this.districtListCopy = this.districtListCopy.slice();
      }
    });
  }

  districtChange(event) {
    this.subDistrictList = [];
    this.cashBookingService
      .talukData(event.value, 1, true)
      .subscribe(result => {
        if (result) {
          this.subDistrictList = result;
          this.subDistrictListCopy = this.subDistrictList;
          this.subDistrictListCopy = this.subDistrictListCopy.slice();
        }
      });
  }

  onproductImageFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/jpeg"
    ) {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.productImageFileName = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.productImagefiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form.controls["productImage_file"].setValue(this.filesResult);
            this.form.controls["productImage_filename"].setValue(file.name);
            this.attachmentData.push({
              id: this.attachmentData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 19
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload JPG, JPEG and PNG  only");
    }
  }

  onleafletFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (file.type === "application/pdf") {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 5000) {
        this.leafletFileName = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.leafletfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form.controls["leaflet_file"].setValue(this.filesResult);
            this.form.controls["leaflet_filename"].setValue(file.name);
            this.attachmentData.push({
              id: this.attachmentData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 20
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 5 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload PDF only");
    }
  }

  onimportFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (file.type === "application/pdf") {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.import_filename = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.leafletfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form.controls["import_file"].setValue(this.filesResult);
            this.form.controls["import_filename"].setValue(file.name);
            this.attachmentData.push({
              id: this.attachmentData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 26
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload PDF only");
    }
  }

  onInvoiceFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (file.type === "application/pdf") {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.invoice_filename = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.leafletfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form1.controls["invoice_file"].setValue(this.filesResult);
            this.form1.controls["invoice_filename"].setValue(file.name);
            this.attachmentData.push({
              id: this.attachmentData.length + 1 - 1,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 25
            });
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload PDF only");
    }
  }

  // onvideoFileSelected(event1: any) {
  //   const file = event1.target.files[0];
  //   if ((file.type === 'video/avi' || file.type === 'video/flv' || file.type === 'video/mp4' || file.type === 'video/wmv')) {
  //     let filesize = file.size;
  //     let acceptsize = parseInt((filesize / 1024).toFixed(2));
  //     if (acceptsize <= 5000) {
  //       this.videoFileName = file.name;
  //       let checkType = file.type;
  //       let getFileType = checkType.split("/")
  //       // this.fileType = getFileType[1]
  //       if (getFileType[1] == 'pdf') {
  //         this.fileType = 2;
  //       } else {
  //         this.fileType = 1;
  //       }
  //       if (file) {
  //         const reader = new FileReader();
  //         reader.readAsDataURL(event1.target.files[0]);
  //         reader.onload = (event: any) => {
  //           this.videofiles = event.target.result;
  //           this.filesResult = event.target.result.split(',')[1];
  //           this.form.controls['video_file'].setValue(this.filesResult);
  //           this.form.controls['video_filename'].setValue(file.name);
  //           this.attachmentData.push({
  //             'id': ((this.attachmentData.length) + 1) - 1,
  //             'base64String': this.filesResult,
  //             'attachmentFilename': file.name,
  //             'fileType': this.fileType,
  //             'attachmentType': 21
  //           });
  //         }
  //       }
  //     } else {
  //       this.alertService.warning('File size is large, Please upload less than 5 MB');
  //     }
  //   } else {
  //     this.alertService.warning('Please upload avi, .flv ,.mp4, .wmv only');
  //   }
  // }

  onCancel() {
    this._location.back();
  }

  onSubmit() {
    this.form.controls["productImage_file"].setValidators(Validators.required);
    this.form.controls["productImage_file"].updateValueAndValidity();
    if (this.form.valid) {
      // this.alertService.success('Product Saved Successfully');
      this.show = true;
      this.datas = true;
      this.make = this.form.value.make;
      this.model = this.form.value.model;
      this.wizardForm.goToNextStep();
    } else {
      this.alertService.error("Please fill the Mandatory fields");
      this.validateFormControl();
    }
  }
  next() {
    if (this.form2.valid) {
      this.show1 = true;
      this.show = false;
      this.datas = true;
      var year = "";
      var curyear = 0;
      var currentYear = new Date().getFullYear();
      var currentMonth = new Date().getMonth();
      if (currentMonth == 1 || currentMonth == 2 || currentMonth == 3) {
        var year = currentYear - 1 + "-" + currentYear;
        curyear = currentYear - 1;
      } else {
        var year = currentYear + "-" + (currentYear + 1);
        curyear = currentYear;
      }
      this.financeyear = year;
      this.form1.controls["financialYear"].setValue(
        currentYear + "-" + (currentYear + 1)
      );
      var stdate = curyear + "/" + "04" + "/" + "01";
      var eddate = curyear + 1 + "/" + "03" + "/" + "31";

      var startdate = moment(new Date(stdate));
      var enddate = moment(new Date(eddate));
      this.form1.controls["stateEffectiveDate"].setValue(startdate);
      this.form1.controls["effectiveEndDate"].setValue(enddate);
      this.dateDisabled = true;
      this.wizardForm.goToNextStep();
    } else {
      this.alertService.error("Please fill the Mandatory fields");
      this.genericValidator.validateFormControl(this.form2);
    }
  }
  previous() {
    this.show = false;
    this.show1 = false;
    this.datas = false;
  }
  back() {
    this.show = true;
    this.show1 = false;
  }
  final() {
    if (this.form.valid && this.form1.valid && this.form2.valid) {
      this.form1.controls['stateEffectiveDate'].setValue(moment(this.form1.value.stateEffectiveDate).format('YYYY-MM-DD'));
      this.stateEffectiveDate = this.form1.value.stateEffectiveDate
      this.isSubmit = true;
      let capacity = parseInt(this.form.value.capicity);
      let data = {
        dbtProductId: parseInt(this.product),
        make: this.form.value.make,
        model: this.form.value.model,
        capicity: capacity != null && capacity > 0 ? capacity : 0,
        productReleaseYear: this.form.value.releasedate.toString(),
        // productReleaseMonth: (this.form.value.releasemonth).toString(),
        warrantyYear: parseInt(this.form.value.warrantyYear),
        warrantyMonth: parseInt(this.form.value.warrantyMonth),
        // warrantyHour: (this.form.value.warrantyHour > 0 ? JSON.parse(this.form.value.warrantyHour) : 0),
        specification: this.form.value.specification,
        additionalFeature: this.form.value.specialFeature,
        testReportNo: this.form2.value.testreportno,
        dbtTestingCentreId: this.form2.value.testfrom,
        validityStartTs: this.form2.value.startdate,
        validityEndTs: this.form2.value.enddate,
        financialYear: this.form1.value.financialYear,
        price: this.form1.value.price,
        webUrl: this.form.value.website,
        isImportedProduct: this.importyes,
        dbtgstId: this.form1.value.dbtgstId,
        unitPrice: parseInt(this.form1.value.unitPrice),
        effectiveFromTs: this.stateEffectiveDate,
        attachment: this.attachmentData,
        telematicsKitCost: Number(this.form1.value.TelematicsCost) || 0,
      };
      this.productService.save(data).subscribe(res => {
        if (res && res.isSuccess) {
          this.alertService.success("Product Saved Successfully");
          this.navigationService.gotoProduct(0);
        } else {
          this.alertService.error(res.htmlFormattedFailures);
        }
        this.isSubmit = false;
      });
    } else {
      this.alertService.error("Please fill the Mandatory fields");
      this.genericValidator.validateFormControl(this.form1);
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    });
  }

  open(data: any, index: number): void {
    // open lightbox
    // this.images = ['https://mdbootstrap.com/img/Photos/Slides/img%20(130).jpg', 'https://mdbootstrap.com/img/Photos/Slides/img%20(129).jpg', 'https://mdbootstrap.com/img/Photos/Slides/img%20(70).jpg'];
    //this._lightbox = []
    let currbase64string = "data:image/jpg;base64," + data.base64String;
    this.images = [];
    const images = this.attachmentData.map((e, index) => {
      if (e.fileType == 1) {
        this.images.push({
          src: "data:image/jpg;base64," + e.base64String,
          // caption: 'image' + (index + 1),
          thumb: "data:image/jpg;base64," + e.base64String
        });
      }
    });
    let findindex = this.images.findIndex(x => x.src === currbase64string);
    this._lightbox.open(this.images, findindex, { centerVertically: true });
  }
  OndeleteAttachment(i) {
    // let getName = this.attachmentData[i].attachmentTypeName;
    let getName = "Attachment";
    this.deleteuploadData(`You want to Delete ${getName} ?`, i);
  }
  deleteuploadData(message: string, index: number) {
    const title = this.translate.instant("DeleteConfirmation");
    const Yes = this.translate.instant("Yes");
    const No = this.translate.instant("No");
    swal
      .fire({
        title,
        text: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: Yes,
        cancelButtonText: No
      })
      .then(res => {
        if (res.value) {
          // const data = this.attachmentsDataSource.data;
          // if (data[index].statusType === 1) {
          //   const filteredData = _.find(this.attachmentData, e => (e.id === data[index].id));
          //   filteredData.statusType = 3;
          // } else {
          //   _.remove(this.attachmentData, function (e) {
          //     return (e.id === data[index].id && e.attachmentFilename === data[index].attachmentFilename
          //       && e.attachmentType === data[index].attachmentType)
          //   });
          //   //  data.splice((this.paginator.pageIndex * this.paginator.pageSize) + index, 1);
          // }
          // this.attachmentsDataSource.data = this.attachmentData.filter(e => e.statusType !== 3);

          // this.attachmentDataSource.data = data;
          //this.selectedFileName = '';

          // new method by ganesh

          this.attachmentData = this.attachmentData.filter((item, i) => {
            if (index !== i) return true;
          });
          this.attachmentlen = this.attachmentlen.splice(
            1,
            this.attachmentlen.length
          );
          this.attachmentsDataSource.data = this.attachmentData;
        }
      });
  }

  download(data: any, index: number) {
    this.driverService.downloadAttachment(data.id, true).subscribe(result => {
      if (result) {
        const resultData = result.base64String;
        const resultname = result.attachmentFilename;
        let a = document.createElement("a"); //Create <a>
        a.href = "data:application/octet-stream;base64," + resultData;
        a.target = "new";
        a.download = resultname; //File name Here
        a.click(); //Downloaded file
        a.remove();
      }
    });
  }

  onFileSelected(event1) {
    const file = event1.target.files[0];
    let ext = file.name.split(".").pop();
    if (
      file &&
      (file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/jpeg")
    ) {
      if (this.attachmentlen.length < 4) {
        if (ext !== "pdf") {
          this.fileType = 1;
        } else {
          this.fileType = 2;
        }
        this.selectedFileName = file.name;
        let filesize = file.size;
        let acceptsize = parseInt((filesize / 1024).toFixed(2));
        if (acceptsize < 1000) {
          if (event1.target.files && event1.target.files[0]) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.filesResult = event.target.result.split(",")[1];
              if (this.filesResult) {
                this.form.controls["productImage_file"].setValue(
                  this.filesResult
                );
                this.form.controls["productImage_file"].setValue(
                  this.filesResult ? this.selectedFileName : ""
                ); // <-- Set Value for Validation
              }
              this.attachmentlen.push({ id: 0 });

              this.attachmentData.push({
                id: 0,
                attachmentFilename: this.selectedFileName,
                base64String: this.filesResult,
                // attachmentPath: "string",
                attachmentType: 19,
                statusType: 2,
                fileType: this.fileType
              });
              this.attachmentsDataSource.data = this.attachmentData.filter(
                e => e.statusType !== 3
              );
              this.attachmentsDataSource.sort = this.sort;
              this.attachmentsDataSource.paginator = this.paginator;
            };
          }
        } else {
          this.alertService.error(
            "File size is large, Please upload less than 2 MB"
          );
          this.selectedFileName = "";
        }
      } else {
        this.alertService.error(
          "limit exceeded while uploading more than 4 images"
        );
      }
    } else {
      this.alertService.error("Please upload  JPG & PNG images");
    }
  }
  eventHandler(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    var value = Number(e.target.value + e.key) || 0;

    if (
      (keyCode >= 37 && keyCode <= 40) ||
      keyCode == 8 || keyCode == 9 || keyCode == 13 ||
      (keyCode >= 48 && keyCode <= 57)
    ) {
      return this.isValidNumber(value);
    }
    return false;
  }

  isValidNumber(number) {
    return 0 <= number && number <= 11;
  }
  // unitPriceevent(event) {
  //   event.target.value;
  //   if (event.target.value != "") {
  //     this.newunitPrice = parseInt(event.target.value);
  //     if (this.gst == null || this.gst == undefined || this.gst == "") {
  //       this.gst = 0;
  //       this.unitprice =
  //         this.newunitPrice * (this.gst / 100) + this.newunitPrice;
  //       this.form1.controls["price"].setValue(this.unitprice);
  //     } else {
  //       this.unitprice =
  //         this.newunitPrice * (this.gst[0].price / 100) + this.newunitPrice;
  //       this.form1.controls["price"].setValue(this.unitprice);
  //     }
  //   } else {
  //     this.form1.controls["price"].setValue(" ");
  //   }
  // }

  unitPriceevent(event) {
    debugger
    this.calculateTotalMRP();
  }

  onChange() {
    debugger
    this.calculateTotalMRP();
  }


  clear(event) {
    event.target.value = null;
  }

  calculateTotalMRP() {
    debugger
    const unitPriceStr = this.form1.get('unitPrice')?.value;
    const unitPrice = parseFloat(unitPriceStr) || 0;

    let gstPercentage = 0;
    const dbtgstId = this.form1.get('dbtgstId')?.value;

    if (this.gstListCopy && dbtgstId) {
      const gstObj = this.gstListCopy.find(i => i.key == dbtgstId);
      if (gstObj) {
        gstPercentage = parseFloat(gstObj.price) || 0;
      }
    }

    const basePrice = unitPrice + (unitPrice * (gstPercentage / 100));

    const telematicsValue = this.form1.get('TelematicsCost')?.value;

    const telematicsCost = (telematicsValue === '' || telematicsValue === null || telematicsValue === undefined)
      ? 0
      : parseFloat(telematicsValue) || 0;

    const totalCostMRP = basePrice + telematicsCost;

    if (unitPriceStr !== '' && unitPriceStr !== null && unitPriceStr !== undefined) {
      this.form1.get('price')?.setValue(totalCostMRP.toFixed(2), { emitEvent: false });
    } else {
      this.form1.get('price')?.setValue(" ", { emitEvent: false });
    }
  }
}
